export default {
  title: 'Artikel',
};
